import { FaTrash } from "react-icons/fa";

const QualificationsTable = ({ qualifications, setQualifications }) => {

    const removeFile = (current) => {
       
        let newQs = qualifications.filter((qualification) => {
            return qualification !== current;
        });
        setQualifications(newQs);
    }

    return ( 
        <table className="mt-6">
            <thead>
                <tr>
                    <th>Qualification List</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>        
                    {
                       qualifications.map(current => (
                            <tr key={current}>
                                <td>{current}</td>
                                <td><FaTrash color="#af0e19" onClick={() => removeFile(current)}/></td> 
                            </tr>
                        ))
                    }     
            </tbody>
        </table>
     );
}
 
export default QualificationsTable;
